module.exports = __webpack_public_path__ + "static/lokalizacja-puck-tablet-9d062966c2437081f8de85f13f0d64b5.jpg";